import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILocationState, IDepartment, IMunicipality } from "../../../types/locations/locationInterfaces";

const initialState: ILocationState = {
  departments: [],
  municipalities: [],
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setDepartments: (state, action: PayloadAction<IDepartment[]>) => {
      state.departments = action.payload;
    },
    setMunicipalities: (state, action: PayloadAction<IMunicipality[]>) => {
      state.municipalities = action.payload;
    },
  }
});

export const {
  setDepartments,
  setMunicipalities,
} = locationSlice.actions;

export default locationSlice.reducer;
